/**
 * Created by Jerker Nord on 2021-01-28.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {DeadwoodRip} from "../DeadwoodRip";
import {DeadwoodRipSound} from "../sound/DeadwoodRipSound";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {DeadwoodRipS2Symbol} from "../symbol/DeadwoodRipS2Symbol";

export class DeadwoodRipNormalBetPresentation implements FlowStatePresentation {

    private _normalStartDelay:number = 0.06;
    private _fastStartDelay:number = 0.01;

    constructor() {}

    public start(flowStateController:FlowStateController) {
        DeadwoodRip.isSpinning = true;
        DeadwoodRip.playScattersWin = false;
        DeadwoodRip.idle.stop();
        DeadwoodRip.cylinderController.reset();
        if(DeadwoodRip.model.data.nextMode === GameMode.NORMAL) {
            DeadwoodRip.multiplier.reset();
        }
        DeadwoodRip.ways.resetReel(!DeadwoodRip.model.isRestore);
        DeadwoodRip.initialCountUp.remove();
        DeadwoodRip.bigWinCountUp.remove();
        DeadwoodRip.waysWon.remove();
        DeadwoodRip.shootingScreen.enabled = false;
        if(DeadwoodRip.model.data.nextMode === GameMode.FREESPIN_SUPER) {
            const s2 = <DeadwoodRipS2Symbol>DeadwoodRip.reels[4].getSymbol(0);
            s2.resetSuperFS();
        }
        DeadwoodRipSound.soundPlayer.playTrack({name : DeadwoodRipSound.REELS_SPINNING});

        const promises:Promise<any>[] = [];
        DeadwoodRip.reels.forEach((reel, reelId) => {
            const lockReel = DeadwoodRip.model.data.nextMode === GameMode.FREESPIN_SUPER && reelId === 4;
            promises.push(reel.startSpin(!lockReel, (SlotGame.apiPlugin.settings.get(APISetting.FAST_SPIN) ? this._fastStartDelay : this._normalStartDelay) * reelId));
        });

        Promise.all(promises).then(res => flowStateController.finish());
    }
}